// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from "vuex";
import cstmTable from "../../../../share/components/vue/PaginationImgTable";
import error from '../../../../common/nodejs/errors';
import config from '../../../../share/config';
import session from '../../../../share/session';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
// image
const imgHeightMinus = require("@/assets/individualWorkSupport/requirement071/height_minus.png");
const imgHeightPlus = require("@/assets/individualWorkSupport/requirement071/height_plus.png");
const imgPitchMinus = require("@/assets/individualWorkSupport/requirement071/pitch_minus.png");
const imgPitchPlus = require("@/assets/individualWorkSupport/requirement071/pitch_plus.png");
const imgRollMinus = require("@/assets/individualWorkSupport/requirement071/roll_minus.png");
const imgRollPlus = require("@/assets/individualWorkSupport/requirement071/roll_plus.png");
const imgYawMinus = require("@/assets/individualWorkSupport/requirement071/yaw_minus.png");
const imgYawPlus = require("@/assets/individualWorkSupport/requirement071/yaw_plus.png");

/** 各フェーズ定義 */
const PHASE = {
  STANDBY: 'standby',
  UPDATE: 'update',
  PROGRESS: 'progress',
  CREATE: 'create',
  FAILED: 'failed',
  START_ERROR: 'start_error',
  STOP_ERROR: 'stop_error',
  COMMUNICATION_ERROR: 'communication_error',
  ERROR: 'error',
};

/** API type定義 */
const API_TYPE = {
  START: 'start',
  WRITE: 'write',
  CREATE: 'create',
  CREATE_STOP: 'createStop',
  STOP: 'stop',
  TERMINATE: 'terminate',
};

/** 計算種別 */
const MATH_TYPE = {
  ADD: 'add',
  SUBTRACT: 'subtract',
};

/** パラメータ設定 */
const PARAM_CONFIG = {
  YAW: {
    MAX: 50,
    MIN: -50,
    STEP: 1,
  },
  PITCH: {
    MAX: 50,
    MIN: -50,
    STEP: 1,
  },
  ROLL: {
    MAX: 50,
    MIN: -50,
    STEP: 1,
  },
  HEIGHT: {
    MAX: 99,
    MIN: -99,
    STEP: 1,
  },
};

export default {
  name: "requirement071",
  data() {
    return {
      phase: PHASE.STANDBY,
      nextPhase: null,
      isLoading: false,
      isMathButtonDisabled: true,
      isToStop: false,
      calibrationErrorMessage: "",
      startProcessErrorMessage: "",
      // テーブル関連
      columnsPhaseUpdate: [],
      itemsPhaseUpdate: [],
      columnsPhaseCreate: [],
      itemsPhaseCreate: [],
      tableParam: {
        yaw: null,
        pitch: null,
        roll: null,
        height: null,
      },
      selectedItemId: null,
      modal_requirement_071: false
    };
  },

  props: {
    workSupportId: { type: Number, default: "", required: true }
  },

  components: {
    "cstm-table": cstmTable
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),

    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.FAILED:
        case PHASE.START_ERROR:
        case PHASE.STOP_ERROR:
        case PHASE.COMMUNICATION_ERROR:
        case PHASE.ERROR:
          return "danger";
        case PHASE.STANDBY:
        case PHASE.UPDATE:
        case PHASE.PROGRESS:
        case PHASE.CREATE:
        default:
          return "secondary";
      }
    },

    /** パラメータ更新画面のテーブルデータ作成 */
    systemColumnsPhaseUpdate() {
      // 列
      this.columnsPhaseUpdate = [
        {
          name: "itemName",
          label: "individual.label_table_item",
          useResource: true
        },
        {
          name: "itemImageMinus",
          label: "individual.label_minus",
          useImage: true
        },
        {
          name: "itemImagePlus",
          label: "individual.label_plus",
          useImage: true
        },
        {
          name: "itemValue",
          label: "individual.label_table_parameter",
        }
      ];

      // データ
      this.createItemsPhaseUpdate();

      return this.columnsPhaseUpdate;
    },

    /** パラメータ更新画面のテーブルデータ作成 */
    systemColumnsPhaseCreate() {
      // 列
      this.columnsPhaseCreate = [
        {
          name: "itemName",
          label: "individual.label_table_item",
          useResource: true
        },
        {
          name: "itemValue",
          label: "individual.label_table_parameter",
        }
      ];

      // データ
      this.createItemsPhaseCreate();

      return this.columnsPhaseCreate;
    },
  },

  methods: {
    ...mapActions("auth", ["logout", "resetSession"]),

    /** 初期化処理 */
    init() {
      this.modal_requirement_071 = true;
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** その他エラー発生時の表示 */
    showUnexpectedError() {
      // 共通エラー画面の場合は、ウィザードを閉じる
      if (this.phase === PHASE.ERROR) {
        this.closeWizard();
        return;
      }
      // 異常終了：エラー表示
      this.phase = PHASE.ERROR;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit("close-wizard");
      this.modal_requirement_071 = false;
    },

    /** 開始処理 */
    async doStart() {
      try {
        this.isLoading = true;

        // 値変更ボタンを非活性に変更
        this.isMathButtonDisabled = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.START
        };

        // start API実行
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了
              this.tableParam.yaw = response.data.user_data.read_value.yaw;
              this.tableParam.pitch = response.data.user_data.read_value.pitch;
              this.tableParam.roll = response.data.user_data.read_value.roll;
              this.tableParam.height = response.data.user_data.read_value.height;

              // 画面更新
              this.phase = PHASE.UPDATE;
              this.$nextTick(() => {
                this.createItemsPhaseUpdate();
              });
              break;
            case config.STATUS_WSP_FAILED:
              switch (response.data.async_code) {
                case error.WSP_071_START_PROCESS_ERROR:
                  // 開始処理エラー
                  this.updateStartProcessErrorMessage(response.data.user_data.error_type);
                  this.nextPhase = null;
                  this.phase = PHASE.START_ERROR;
                  break;
                case error.WSP_071_COMMUNICATION_ERROR:
                  // 通信エラー
                  this.phase = PHASE.COMMUNICATION_ERROR;
                  break;
                default:
                  // 共通エラー
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 書込み処理 */
    async doWrite() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.WRITE,
          write_value: this.tableParam,
        };

        // start API実行
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了
              // 画面更新
              this.phase = PHASE.CREATE;
              this.$nextTick(() => {
                this.createItemsPhaseCreate();
              });
              break;
            case config.STATUS_WSP_FAILED:
              switch (response.data.async_code) {
                case error.WSP_071_START_PROCESS_ERROR:
                  // 開始処理エラー
                  this.updateStartProcessErrorMessage(response.data.user_data.error_type);
                  this.nextPhase = PHASE.CREATE;
                  this.phase = PHASE.START_ERROR;
                  break;
                case error.WSP_071_COMMUNICATION_ERROR:
                  // 通信エラー
                  this.phase = PHASE.COMMUNICATION_ERROR;
                  break;
                default:
                  // 共通エラー
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.selectedItemId = null;
        this.updateRowHighLight(this.itemsPhaseUpdate);
        this.isLoading = false;
      }
    },

    /** 生成処理 */
    async doCreate() {
      let ret = false;
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.CREATE
        };

        // start API実行
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了
              ret = true;
              break;
            case config.STATUS_WSP_FAILED:
              switch (response.data.async_code) {
                case error.WSP_071_CALIBRATION_FAILED:
                  // キャリブレーション失敗
                  this.updateFailedMessage();
                  this.phase = PHASE.FAILED;
                  break;
                case error.WSP_071_START_PROCESS_ERROR:
                  // 開始処理エラー
                  this.updateStartProcessErrorMessage(response.data.user_data.error_type);
                  this.nextPhase = PHASE.UPDATE;
                  this.phase = PHASE.START_ERROR;
                  break;
                case error.WSP_071_COMMUNICATION_ERROR:
                  // 通信エラー
                  this.phase = PHASE.COMMUNICATION_ERROR;
                  break;
                case error.WSP_071_TO_STOP_COMMUNICATION_ERROR:
                  // 通信エラー
                  this.isToStop = true;
                  this.phase = PHASE.COMMUNICATION_ERROR;
                  break;
                default:
                  // 共通エラー
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }

      // 処理成功時
      if (ret) {
        await this.doCreateStop();
      }
    },

    /** 生成停止処理 */
    async doCreateStop() {
      let ret = false;
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.CREATE_STOP,
        };

        // start API実行
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了
              ret = true;
              break;
            case config.STATUS_WSP_FAILED:
              // 停止処理エラー
              this.isToStop = true;
              this.phase = PHASE.STOP_ERROR;
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }

      // 処理成功時
      if (ret) {
        await this.doStop();
      }
    },

    /** 停止処理 */
    async doStop() {
      let ret = false;
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.STOP,
        };

        // start API実行
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了
              ret = true;
              break;
            case config.STATUS_WSP_FAILED:
              // 停止処理エラー
              this.phase = PHASE.STOP_ERROR;
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }

      // 処理成功時
      if (ret) {
        await this.doTerminate();
      }
    },

    /** 終了処理 */
    async doTerminate() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.TERMINATE
        };

        // start API実行
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 応答が返ってきたらダイアログを閉じる
          this.closeWizard();
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** パラメータ更新画面のテーブルデータ作成 */
    createItemsPhaseUpdate() {
      // データ
      this.itemsPhaseUpdate = [
        {
          itemID: 0,
          itemName: "individual.label_yaw",
          itemImageMinus: imgYawMinus,
          itemImagePlus: imgYawPlus,
          itemValue: this.tableParam.yaw,
        },
        {
          itemID: 1,
          itemName: "individual.label_pitch",
          itemImageMinus: imgPitchMinus,
          itemImagePlus: imgPitchPlus,
          itemValue: this.tableParam.pitch,
        },
        {
          itemID: 2,
          itemName: "individual.label_roll",
          itemImageMinus: imgRollMinus,
          itemImagePlus: imgRollPlus,
          itemValue: this.tableParam.roll,
        },
        {
          itemID: 3,
          itemName: "individual.label_height",
          itemImageMinus: imgHeightMinus,
          itemImagePlus: imgHeightPlus,
          itemValue: this.tableParam.height,
        }
      ];
    },

    /** パラメータ更新画面のテーブルデータ作成 */
    createItemsPhaseCreate() {
      // データ
      this.itemsPhaseCreate = [
        {
          itemID: 0,
          itemName: "individual.label_yaw",
          itemValue: this.tableParam.yaw,
        },
        {
          itemID: 1,
          itemName: "individual.label_pitch",
          itemValue: this.tableParam.pitch,
        },
        {
          itemID: 2,
          itemName: "individual.label_roll",
          itemValue: this.tableParam.roll,
        },
        {
          itemID: 3,
          itemName: "individual.label_height",
          itemValue: this.tableParam.height,
        }
      ];
    },

    /** テーブル行の強調表示更新 */
    updateRowHighLight(array) {
      array.forEach(item => {
        if (item.itemID === this.selectedItemId) {
          item.fieldSpec = {};
          item.fieldSpec.itemName = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.itemValue = config.LIST_ITEM_HIGHLIGHT;
        } else {
          if (item.fieldSpec) {
            delete item.fieldSpec;
          }
        }
      });
    },

    /** 値変更操作の反映 */
    updateChangeValue(conf, type, value) {
      let ret = value;
      switch (type) {
        case MATH_TYPE.ADD:
          if (conf.MAX >= (value + conf.STEP)) {
            ret = value + conf.STEP;
          }
          break;
        case MATH_TYPE.SUBTRACT:
          if (conf.MIN <= (value - conf.STEP)) {
            ret = value - conf.STEP;
          }
          break;
        default:
          break;
      }
      return ret;
    },

    /** キャリブレーション失敗時のメッセージを更新 */
    updateFailedMessage() {
      switch (this.workSupportId) {
        case 7101:
          this.calibrationErrorMessage = "individual.label_error_front";
          break;
        case 7102:
          this.calibrationErrorMessage = "individual.label_error_left";
          break;
        case 7103:
          this.calibrationErrorMessage = "individual.label_error_right";
          break;
        case 7104:
          this.calibrationErrorMessage = "individual.label_error_rear";
          break;
        default:
          break;
      }
    },

    /** 開始処理エラーメッセージ更新 */
    updateStartProcessErrorMessage(type) {
      switch (type) {
        case "00":
          this.startProcessErrorMessage = "individual.data_read_ws71_0x00";
          break;
        case "11":
          this.startProcessErrorMessage = "individual.data_read_ws71_0x11";
          break;
        case "12":
          this.startProcessErrorMessage = "individual.data_read_ws71_0x12";
          break;
        case "13":
          this.startProcessErrorMessage = "individual.data_read_ws71_0x13";
          break;
        case "14":
          this.startProcessErrorMessage = "individual.data_read_ws71_0x14";
          break;
        case "51":
          this.startProcessErrorMessage = "individual.data_read_ws71_0x51";
          break;
        case "52":
          this.startProcessErrorMessage = "individual.data_read_ws71_0x52";
          break;
        case "61":
          this.startProcessErrorMessage = "individual.data_read_ws71_0x61";
          break;
        case "62":
          this.startProcessErrorMessage = "individual.data_read_ws71_0x62";
          break;
        case "63":
          this.startProcessErrorMessage = "individual.data_read_ws71_0x63";
          break;
        case "64":
          this.startProcessErrorMessage = "individual.data_read_ws71_0x64";
          break;
        case "65":
          this.startProcessErrorMessage = "individual.data_read_ws71_0x65";
          break;
        default:
          this.startProcessErrorMessage = "individual.data_read_ws71_other";
          break;
      }
    },


    // ユーザ操作
    /** パラメータ更新画面 OK押下 */
    async onUpdateOkClicked() {
      this.phase = PHASE.PROGRESS;
      this.doWrite();
    },

    /** パラメータ更新画面 キャンセル押下 */
    async onUpdateCancelClicked() {
      this.doStop();
    },

    /** パラメータ更新画面 テーブル行押下 */
    onUpdateRowClicked(data) {
      if (this.isLoading) {
        return;
      }
      this.selectedItemId = data.itemID;
      this.updateRowHighLight(this.itemsPhaseUpdate);
      this.isMathButtonDisabled = false;
    },

    /** パラメータ更新画面 OK押下 */
    async onUpdateChangeValueClicked(type) {
      switch (this.selectedItemId) {
        case 0:
          this.tableParam.yaw = this.updateChangeValue(
            PARAM_CONFIG.YAW, type, this.tableParam.yaw);
          break;
        case 1:
          this.tableParam.pitch = this.updateChangeValue(
            PARAM_CONFIG.PITCH, type, this.tableParam.pitch);
          break;
        case 2:
          this.tableParam.roll = this.updateChangeValue(
            PARAM_CONFIG.ROLL, type, this.tableParam.roll);
          break;
        case 3:
          this.tableParam.height = this.updateChangeValue(
            PARAM_CONFIG.HEIGHT, type, this.tableParam.height);
          break;
        default:
          break;
      }
      this.$nextTick(() => {
        this.updateRowHighLight(this.itemsPhaseUpdate);
      });
    },

    /** マップ生成処理開始画面 OK押下 */
    async onCreateOkClicked() {
      this.doCreate();
    },

    /** マップ生成処理開始画面 キャンセル押下 */
    async onCreateCancelClicked() {
      this.doStop();
    },

    /** マップ生成処理開始画面 再入力押下 */
    async onCreateReenterClicked() {
      this.isMathButtonDisabled = true;
      this.phase = PHASE.UPDATE;
    },

    /** キャリブレーション失敗画面 OK押下 */
    async onFailedOkClicked() {
      this.doStop();
    },

    /** 開始処理エラー画面 OK押下 */
    async onStartErrorOkClicked() {
      if (this.nextPhase) {
        this.phase = this.nextPhase;
        switch (this.nextPhase) {
          case PHASE.CREATE:
            this.$nextTick(() => {
              this.createItemsPhaseCreate();
            });
            break;
          case PHASE.UPDATE:
            this.$nextTick(() => {
              this.createItemsPhaseUpdate();
            });
            break;
          default:
            break;
        }
        this.nextPhase = null;
      } else {
        await this.doTerminate();
        this.closeWizard();
      }
    },

    /** 停止処理エラー画面 OK押下 */
    async onStopErrorOkClicked() {
      if (this.isToStop) {
        this.isToStop = false;
        await this.doStop();
      } else {
        await this.doTerminate();
        this.closeWizard();
      }
    },

    /** 通信エラー画面 OK押下 */
    async onCommunicationErrorOkClicked() {
      if (this.isToStop) {
        this.isToStop = false;
        await this.doStop();
      } else {
        await this.doTerminate();
        this.closeWizard();
      }
    },

    /** 共通エラー画面 OK押下 */
    async onErrorOkClicked() {
      await this.doTerminate();
      this.closeWizard();
    },
  },

  async mounted() {
    this.init();
    this.doStart();
  }
};
